import React from 'react'
import { firebaseAuth } from '../../firebase'
import { Button, Icon, Input, Form } from 'antd'

const FormItem = Form.Item
const lang = 'en'
const validationMessages = {
  typeEmail: {
    en: 'The input is not valid e-mail',
    de: 'E-Mail ist ungültig'
  },
  requiredEmail: {
    en: 'Please provide your e-mail',
    de: 'Bitte geben Sie Ihre E-Mail Adresse an'
  }
}

class ForgotPasswordForm extends React.Component {
  state = {
    iconLoading: false,
    responseMessage: null
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({ iconLoading: true, responseMessage: null })
        this.resetPassword(values.email)
      }
    })
  }

  resetPassword (emailAddress) {
    const self = this
    firebaseAuth
      .sendPasswordResetEmail(emailAddress)
      .then(function () {
        self.setState({ iconLoading: false, responseMessage: 'Reset email successfully sent' })
      })
      .catch(function (error) {
        self.setState({ iconLoading: false, responseMessage: error.message })
      })
  }

  render () {
    const { iconLoading, responseMessage } = this.state
    const { forgotPasswordChange, form: { getFieldDecorator } } = this.props

    return (
      <Form onSubmit={this.handleSubmit}>
        <Button
          type='primary'
          shape='circle'
          icon='arrow-left'
          size='default'
          onClick={() => forgotPasswordChange(false)}
        />
        <br /> <br />
        {responseMessage && <p>{responseMessage}</p>}
        <FormItem>
          {getFieldDecorator('email', {
            rules: [
              {
                type: 'email',
                message: validationMessages.typeEmail[lang]
              },
              {
                required: true,
                message: validationMessages.requiredEmail[lang]
              }
            ]
          })(<Input prefix={<Icon type='mail' style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder='Email' />)}
        </FormItem>
        <FormItem>
          <Button type='primary' htmlType='submit' className='login-form-button' loading={iconLoading}>
            Send reset email
          </Button>
        </FormItem>
      </Form>
    )
  }
}

export default Form.create()(ForgotPasswordForm)



// WEBPACK FOOTER //
// ./src/components/Auth/ForgotPasswordForm.js